<template>
  <div id="app">
      <section class="hero is-info">
       
        <div class="hero-body">
          <p class="title has-text-centered">
            GERAKAN PANDAI PODCAST
          </p>
           <!-- <span class="image is-pulled-centered">
              <img src="../assets/logogerpan.png" style="margin-top:5px;margin-left:10px;width:400px"/>
            </span> -->
          <!-- <p class="subtitle">
            Link subtitle
          </p> -->
        </div>
      </section>
      <!-- <b-button  class="button is-light" 
                tag="router-link"
                to="/homepage"
                icon-left="arrow-left-bold">Kembali</b-button> -->
      <!-- <section>
        <b-tabs position="is-centered"  type="is-toggle" expanded>
            <b-tab-item label="Read"></b-tab-item>
            <b-tab-item label="Januari"
            @click="getDataJanuari()">
                <div class="columns is-multiline">
                <div class="column is-one-quarter" v-for="news in newses" :key="news.id">
                  <div class="card">
                    <div class="card-image">
                      <figure class="image is-4by3">
                        <img :src="getPicture(news.picture)" alt="Placeholder image">
                      </figure>    
                    </div>
                  </div>
                </div>
              </div>
            </b-tab-item>
            <b-tab-item label="Februari"></b-tab-item>
            <b-tab-item label="Maret"></b-tab-item>
            <b-tab-item label="April"></b-tab-item>
            <b-tab-item label="Mei"></b-tab-item>
            <b-tab-item label="Juni"></b-tab-item>
            <b-tab-item label="Juli"></b-tab-item>
            <b-tab-item label="Agustus"></b-tab-item>
            <b-tab-item label="September"></b-tab-item>
            <b-tab-item label="Oktober"></b-tab-item>
            <b-tab-item label="November"></b-tab-item>
            <b-tab-item label="Desember"></b-tab-item>
        </b-tabs>
    </section> -->
      <section class="section is-medium" style="padding-top:0.1%;padding-bottom:2%;padding-right:5%;padding-left:5%">
      <div >
          <!-- {{new Date(news.created_at).toLocaleDateString('id-ID',{year:'numeric',month:'long',day:'numeric'}) }}
              <p v-html="news.news"  style="font-size:17px" class="image animate__animated animate__backInUp"></p> -->
          <b-carousel :autoplay="false">
            <b-carousel-item  v-if="podcast.picture !== null">
                <section class="hero is-large">
                    <div class="hero-head has-text-centered">
                      <span class="image is-5by3">
                      <img style="object-position: center; object-fit: contain"  :src="getPicture(podcast.picture)" >
                      </span>
                    </div>
                </section>
            </b-carousel-item>
            <b-carousel-item  v-if="podcast.picture1 !== null">
                <section class="hero">
                    <div class="hero-head has-text-centered">
                      <span class="image is-5by3">
                        <img style="object-position: center; object-fit: contain"  :src="getPicture(podcast.picture1)">
                      </span>
                    </div>
                </section>
            </b-carousel-item> 
            <b-carousel-item v-if="podcast.picture2 !== null">
                <section class="hero">
                    <div class="hero-head has-text-centered">
                      <span class="image is-5by3">
                      <img style="object-position: center; object-fit: contain"  :src="getPicture(podcast.picture2)">
                      </span>
                    </div>
                </section>
            </b-carousel-item>
            
            <b-carousel-item v-if="podcast.url !=null">
                <section class="hero">
                    <div class="hero-head has-text-centered">
                      <span class="image is-5by3">
                        <iframe class="has-ratio" width="640" height="360" 
                          :src="podcast.url" frameborder="0" allowfullscreen></iframe>
                      </span>
                    </div>
                </section>
            </b-carousel-item> 
          
          </b-carousel>
          
        <!-- </div> -->
     </div>
    </section>
    <section>
      <div class="container" style="text-align:justify;padding-left:8%;padding-right:8%">
        <h1 class="image animate__animated animate__backInUp has-text-centered" style="color:blue; font-size:20px"><b>{{podcast.title}}</b></h1>
        <br>
        
        <p v-html="podcast.deskripsi"  style="font-size:17px;"></p>
        <br>
        Uploaded:
        <b-icon
            icon="timer"
            size="is-small">
        </b-icon>
          {{new Date(podcast.created_at).toLocaleDateString('id-ID',{year:'numeric',month:'long',day:'numeric'}) }}
          <br>
          <!-- <div class="is-pulled-left" style="margin-left:10px">
          <b-button  class="button is-info" 
        tag="router-link"
        to="/homepage"
        icon-left="arrow-left-bold">Back to Home</b-button>
        </div> -->

      </div>
      <br>
        
    </section>
      <section class="hero is-info">
        <div class="rows">
            <div class="row">
                <div class="column">
                      <b-button  class="button is-info" 
                        tag="router-link"
                        to="/homepage"
                        icon-left="arrow-left-bold">Back to Home</b-button>
                </div>
            </div>
        </div>     
      </section>
  
    
    <!-- <section>
      <div class="hero-body">
        <p style="font-weight:bold">Kumpulan Galeri Photo</p>
         <b-carousel-list v-model="test" :data="items" :items-to-show="2">
        <template #item="list">
            <div class="card">
                <div class="card-image">
                    <figure class="image is-5by3">
                        <a @click="info(list.index)"><img :src="list.image"></a>
                    </figure>
                    <b-tag type="is-danger" rounded style="position: absolute; top: 0;"><b>Galeri</b></b-tag>
                </div>
            </div>
        </template>
    </b-carousel-list>
      </div>
    </section> -->

    <!-- <section>
      <div class="hero-body">
        <span class="image is-3by1" >
              <img style="object-position: center; object-fit: contain" src="../assets/tigagambar.png">
        </span>
      </div>
    </section> -->
   
  </div>
</template>

<script>

export default {
        data() {
            return {
              carousel:true,
              isLoading: false,
              podcast:'',
              cariPodcast:'',
              id_podcast:'',
              podcasts:[],
              // acara:Object,
              // berita:Object,
              // isDetail:false,
              config: {},
              test: 0,
            items: [
                  // {
                //     title: 'Slide 1',
                //     image: 'https://lh3.googleusercontent.com/proxy/fZqYBy499aLJL7t01LZ5P35fsqgb991hlKANoz6u567rj3mD0L7rFZi26ZgdA3_aIQcO_g8J3tou_YhrxvffNos_vxZ3H5PwUXbP8bVXBApBlStBeQ'
                // },
                // {
                //     title: 'Slide 2',
                //     image: 'https://smpn2yogya.sch.id/wp-content/uploads/2019/10/WhatsApp-Image-2019-10-26-at-09.02.10-1210x423.jpeg'
                // },
                // {
                //     title: 'Slide 3',
                //     image: 'https://3.bp.blogspot.com/-mMpiliByz48/W4zGwUL_tpI/AAAAAAAAUgQ/4U0zzjX9GgoL2otsIFVmdTTBL06KuLqogCLcBGAs/s1600/40615875_10215447425770669_892645202274025472_o.jpg'
                // },
                {
                    title: 'Slide 4',
                    image: 'https://socs.binus.ac.id/files/2018/09/WhatsApp-Image-2018-08-31-at-10.35.19-640x360.jpeg'
                },
                // {
                //     title: 'Slide 5',
                //     image: 'https://awsimages.detik.net.id/community/media/visual/2020/02/18/10743aed-3927-4a79-b385-1d9b1fb70389_169.jpeg?w=700&q=90'
                // },
                {
                    title: 'Slide 6',
                    image: 'https://miro.medium.com/max/1240/0*allclr5UmQ8F1PRg.jpg'
                },
                {
                    title: 'Slide 7',
                    image: 'https://sekolahtumbuh.sch.id/wp-content/uploads/2020/01/WhatsApp-Image-2020-01-28-at-14.03.32-750x458.jpeg'
                },
                // {
                //     title: 'Slide 8',
                //     image: 'https://umrah.ac.id/wp-content/uploads/2017/11/bebras.jpg'
                // },
                 {
                    title: 'Slide 9',
                    image: 'https://www.sttgarut.ac.id/wp-content/uploads/2020/06/img693.jpg'
                },
                //  {
                //     title: 'Slide 10',
                //     image: 'https://dinus.ac.id/images/news/670c7-IMG_0269--.jpg'
                // },
                 {
                    title: 'Slide 11',
                    image: 'https://cdn.krjogja.com/wp-content/uploads/2020/12/IMG-20201204-WA0000.jpg'
                },
                //  {
                //     title: 'Slide 12',
                //     image: 'https://cdn.timesmedia.co.id/images/2020/11/24/Siswa-SMA-Pradita-Dirgantara.jpg'
                // },
                //  {
                //     title: 'Slide 13',
                //     image: 'https://dinus.ac.id/images/news/66cc9-bebras-1.jpeg'
                // },
                 {
                    title: 'Slide 14',
                    image: 'https://socs.binus.ac.id/files/2018/09/WhatsApp-Image-2018-08-31-at-10.00.02.jpeg'
                },
                 {
                    title: 'Slide 15',
                    image: 'https://i.ytimg.com/vi/Yl7F0J8LbGQ/maxresdefault.jpg'
                },
                 {
                    title: 'Slide 16',
                    image: 'https://ft.ulm.ac.id/id/wp-content/uploads/2020/09/ss7-MUTIA-MAULIDA.png'
                },
                //  {
                //     title: 'Slide 17',
                //     image: 'https://2.bp.blogspot.com/-8j13bl_LiT8/W_KMJBaLDRI/AAAAAAAABME/Bv5wL2OgfXQfnZxC3TGK-GLLh8brmFLOQCLcBGAs/s1600/IMG_20181115_091938.jpg'
                // },
                 {
                    title: 'Slide 18',
                    image: 'https://pbs.twimg.com/media/EeFZaouUMAAztA4.png'
                },
                //  {
                //     title: 'Slide 19',
                //     image: 'https://3.bp.blogspot.com/-W12atIs7Gjg/WqzlDZeWtSI/AAAAAAAAJoU/MA_oM7mbn_oVVmLJPTjns2Nwg7hemc8kACLcBGAs/s1600/Poster%2B02.JPG'
                // },



            ]
            }
        },
    methods: {

    getData(id_podcast)
    {
      this.isLoading=true
      var uri = this.$apiUrl + 'podcast/' + id_podcast

      this.$http.get(uri).then(response =>
      {
        this.podcast = response.data.value
      })
    },
    getPicture(picture){
        var uri = this.$apiUrl + 'podcast/picture/' + picture
          
        return uri;
      },
     
    },
    computed: {
    },
    mounted()
    {
    if(this.$route.params.id) {           
      this.id_podcast = this.$route.params.id
      this.getData(this.id_podcast)  
    }
      console.log(this.search)
    }
}
</script>
